// extracted by mini-css-extract-plugin
export default {"overAllContainer":"intro_overAllContainer__+R1dQ","buttonContainer":"intro_buttonContainer__H+0Tn","test":"intro_test__EJRZ2"};